import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { Close, Phone, Email, LocationOn } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

const ContactInfoPopup = ({ open, onClose, contact }) => {
  const theme = useTheme();
  if (!contact) return null;

  const handleStartCall = () => {
    if (contact.phone) {
      window.location.href = `tel:${contact.phone}`;
    }
  };

  const handleSendEmail = () => {
    if (contact.email) {
      window.location.href = `mailto:${contact.email}`;
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          minWidth: 340,
          maxWidth: 400,
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          overflow: "visible",
        },
      }}
    >
      <DialogContent sx={{ p: 3, position: "relative" }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "#9CA3AF",
            "&:hover": {
              bgcolor: "#F3F4F6",
            },
          }}
        >
          <Close sx={{ fontSize: 20 }} />
        </IconButton>

        {/* Header */}
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            color: "#9CA3AF",
            letterSpacing: 1,
            mb: 3,
          }}
        >
          CONTACT INFORMATION
        </Typography>

        {/* Phone Number */}
        <Box
          sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2.5 }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Phone sx={{ fontSize: 18, color: "primary.main" }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                color: "#9CA3AF",
                fontWeight: 500,
                letterSpacing: 0.5,
                mb: 0.25,
              }}
            >
              PHONE NUMBER
            </Typography>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
              }}
            >
              {contact.phone || "Not available"}
            </Typography>
          </Box>
        </Box>

        {/* Email */}
        <Box
          sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2.5 }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Email sx={{ fontSize: 18, color: "primary.main" }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                color: "#9CA3AF",
                fontWeight: 500,
                letterSpacing: 0.5,
                mb: 0.25,
              }}
            >
              EMAIL ID
            </Typography>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
              }}
            >
              {contact.email || "Not available"}
            </Typography>
          </Box>
        </Box>

        {/* Address */}
        <Box
          sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 3 }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <LocationOn sx={{ fontSize: 18, color: "primary.main" }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                color: "#9CA3AF",
                fontWeight: 500,
                letterSpacing: 0.5,
                mb: 0.25,
              }}
            >
              FULL ADDRESS
            </Typography>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
                lineHeight: 1.4,
              }}
            >
              {contact.address || "Not available"}
            </Typography>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            variant="contained"
            onClick={handleStartCall}
            disabled={!contact.phone}
            sx={{
              flex: 1,
              bgcolor: "primary.main",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              borderRadius: "10px",
              py: 1.25,
              boxShadow: "0 4px 12px primary.main",
              "&:hover": {
                bgcolor: "primary.dark",
              },
              "&:disabled": {
                bgcolor: "#E5E7EB",
                color: "#9CA3AF",
              },
            }}
          >
            Start Call
          </Button>
          <Button
            variant="outlined"
            onClick={handleSendEmail}
            disabled={!contact.email}
            sx={{
              flex: 1,
              borderColor: "primary.main",
              color: "primary.main",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              borderRadius: "10px",
              py: 1.25,
              borderWidth: 2,
              "&:hover": {
                borderColor: "primary.main",
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                borderWidth: 2,
              },
              "&:disabled": {
                borderColor: "#E5E7EB",
                color: "#9CA3AF",
              },
            }}
          >
            Send Email
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContactInfoPopup;
